import { dehydrate, QueryClient } from '@tanstack/react-query';
import { About as AboutPage } from 'components/pages/About';
import { ABOUT_KEY, fetchAboutPage } from 'hooks/pages/useAbout';
import { prefetchCommonData } from 'utils/buildTime';
import { fetchWithSentry } from 'utils/pageTemplates/fetchWithSentry';

export function aboutPage() {
  async function getStaticProps() {
    const queryClient = new QueryClient();

    await fetchWithSentry({
      queryClient,
      queryKey: [ABOUT_KEY],
      queryFn: fetchAboutPage,
      tags: { template: 'aboutPage', api: 'sanity' },
      isRequired: true,
    });

    await prefetchCommonData(queryClient);

    return {
      props: {
        dehydratedState: dehydrate(queryClient),
      },
    };
  }

  const AboutPageComponent = () => <AboutPage />;

  return {
    getStaticProps,
    AboutPageComponent,
  };
}
